import { CHECKLIST_STEP_META } from "../constants/stepMeta";
import type { ChecklistStepItem, ChecklistStepMeta } from "../types";

export interface OrderedChecklistStep {
  meta: ChecklistStepMeta;
  stepData: ChecklistStepItem;
}

/**
 * 清单页步骤展示顺序：已完成置顶、未完成沉底；两组内部保持 stepMeta 固定顺序（sort 稳定）。
 * 未完成组首项即 firstIncompleteStepId 对应项，打开页时自动展开逻辑不受影响。
 * 后端缺某项数据时按未完成兜底展示。
 */
export function getOrderedChecklistSteps(
  steps?: readonly ChecklistStepItem[],
): OrderedChecklistStep[] {
  return CHECKLIST_STEP_META.map((meta) => ({
    meta,
    stepData: steps?.find((s) => s.stepId === meta.stepId) ?? {
      stepId: meta.stepId,
      stepKey: meta.stepKey,
      completed: false,
      completedAt: null,
    },
  })).sort(
    (a, b) => Number(b.stepData.completed) - Number(a.stepData.completed),
  );
}
